import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import logo from "../../assets/transparent_logo.png";
import BAScreenHeader from "../components/BAScreenHeader";
import BAButton from "../components/BAButton";
import BASelect from "../../config/components/BASelect";
import { useReactToPrint } from "react-to-print";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import { setDate } from "./helpermethod";
import BAGrid from "../components/BAGrid";
import PaidStamp from '../../assets/PaidStamp.png'
import { Box, Typography } from "@mui/material";

function PageHeader(props) {
  const { receiptNo } = props;
  return (
    <>
      <div
        style={{ backgroundColor: "#052027", borderRadius: "0 0 50px 0" }}
        className="d-flex p-3 justify-content-between align-items-center"
      >
        <div className="text-light">
          <h1 className="m-0 p-0">Invoice</h1>
          <p className="m-0 p-0">{receiptNo}</p>
        </div>
        <img src={logo} width="100px" alt="Logo" />
      </div>
    </>
  );
}
function PageFooter() {
  return (
    <>
      <div
        style={{ backgroundColor: "#04191e", borderRadius: "30px 30px 0 0" }}
        className="p-3 text-white"
      >
        <div>
          <p className="p-0 m-0">
            <span className="me-2" style={{ color: "#e9c474" }}>
              <LocalPhoneIcon />
            </span>{" "}
            +923004128984
          </p>
          <p className="p-0 m-0">
            <span className="me-2" style={{ color: "#e9c474" }}>
              <EmailIcon />
            </span>{" "}
            mubashircurtain786@gmail.com
          </p>
          <p className="p-0 m-0">
            <span className="me-2" style={{ color: "#e9c474" }}>
              <HomeWorkIcon />
            </span>{" "}
            shop #28 sawana city near waseem bagh 13-D/3 gulshan-e-iqbal
            Karachi,
          </p>
        </div>
      </div>
    </>
  );
}

function PrintDocument(props) {
  const {
    customerName,
    amount,
    advanceAmount,
    city,
    companyName,
    contact,
    createdAt,
    discount,
    orderDetails,
    orderNo,
    receiptNo,
    remainingAmount,
    totalAmount,
    updatedAt,
    address,
    isPaid,
  } = props.model;
  const imageRef = useRef(null);

  const [printBy, setPrintBy] = useState(1);

  const generateImage = async () => {
    if (imageRef.current) {
      const canvas = await html2canvas(imageRef.current);
      const imageSrc = canvas.toDataURL("image/png");
      shareImage(imageSrc);
    }
  };
  const createPdf = useReactToPrint({
    content: () => imageRef.current,
    documentTitle: receiptNo,
  });

  const shareImage = (imageSrc) => {
    const whatsappMessage = "Check out this cool image!";
    // const whatsappURL =
    //   "https://api.whatsapp.com/send?text=" +
    //   encodeURIComponent(whatsappMessage) +
    //   "&image=" +
    //   encodeURIComponent(imageSrc);

    // window.open(whatsappURL, "_blank");
    const link = document.createElement("a");
    link.href = imageSrc;
    link.download = receiptNo;
    link.click();
  };

  const createPages = (list) => {
    for (let i = 0; i < orderDetails.length; i++) {
      orderDetails[i].sNo = i + 1;
    }
    let arr = [];
    for (let i = 0; i <= list.length; i += 6) {
      let a = list.slice(i, i + 6)
      if (a.length > 0) {
        arr.push(a);
      }
    }
    console.log(arr)
    return arr;
  };

  useEffect(() => {

    if (createPages(orderDetails).length > 1) {
      setPrintBy(2);
    }
  }, []);

  return (
    <div className="bg-transparent">
      <BAScreenHeader
        title="Print Invoice"
        buttonsList={[
          {
            displayField: (
              <BASelect
                onChange={(e) => setPrintBy(e.target.value)}
                value={printBy}
                datasource={
                  createPages(orderDetails).length > 1
                    ? [
                      {
                        id: 2,
                        displayName: "PDF",
                      },
                    ]
                    : [
                      {
                        id: 1,
                        displayName: "Image",
                      },
                      {
                        id: 2,
                        displayName: "PDF",
                      },
                    ]
                }
                valueField="id"
                displayField="displayName"
                label="print"
              />
            ),
          },
          {
            displayField: (
              <BAButton
                onClick={printBy == 1 ? generateImage : createPdf}
                label="print"
              />
            ),
          },
        ]}
      />
      <div
        style={{ position: "relative", width: "fit-content", margin: "auto" }}
      >
        <div className="bg-white" ref={imageRef}>
          {createPages(orderDetails).map((pageList, ind) => (
            <div
              style={{ height: "1060px", width: "820px" }}
              className="d-flex flex-column justify-content-between"
              key={ind}
            >
              <PageHeader receiptNo={receiptNo} />
              <div>
                {ind == 0 && (
                  <div className="d-flex mb-2 p-3">
                    <div className="me-1 w-100">
                      <Typography>Order # : <span className="fw-bold">{orderNo ?? '--'}</span></Typography>
                      <Typography>Invoice To : <span className="fw-bold">{customerName ?? '--'}</span></Typography>
                      <Typography>Company : <span className="fw-bold">{companyName ?? '--'}</span></Typography>
                      <Typography>Date : <span className="fw-bold">{createdAt ? setDate(createdAt) : '--'}</span></Typography>
                    </div>
                    <div className="ms-1 w-100">
                      <Typography>Contact : <span className="fw-bold">{contact ?? '--'}</span></Typography>
                      <Typography>Address : <span className="fw-bold">{address ?? '--'}</span></Typography>
                      <Typography>City : <span className="fw-bold">{city ?? '--'}</span></Typography>
                    </div>
                  </div>
                )}
                <div className="p-3">
                  <BAGrid tableClass='table-bordered' isGrouping={true} groupName='groupName' datasource={pageList} gridCols={[
                    {
                      label: 'S.No',
                      key: 'sNo',
                      className: 'btnCell text-center'
                    },
                    {
                      label: 'Description',
                      key: 'name'
                    },
                    {
                      label: 'QTY',
                      key: 'qty',
                      displayField: (e) => <span>{e.qty} {e.unit}</span>
                    },
                    {
                      label: 'Amount',
                      key: 'amount',
                    },
                  ]} />
                  {/* <table className="table border table-light border-dark">
                    <thead>
                      <tr>
                        <th className="text-center" style={{ width: "65px" }}>S.No</th>
                        <th>Description</th>
                        <th>QTY</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(pageList) && pageList.length > 0
                        ? pageList.map((x, i) => (
                          <tr key={i}>
                            <td className="text-center" style={{ width: "65px" }}>{x.sNo}</td>
                            <td>{x.name}</td>
                            <td>
                              {x.qty} {x.unit}
                            </td>
                            <td>{x.amount}</td>
                          </tr>
                        ))
                        : null}
                    </tbody>
                  </table> */}
                  {ind == createPages(orderDetails).length - 1 && (<Box className="d-flex">
                    {isPaid && <Box className="p-4 w-50 h-100 text-center ms-auto">
                      <img width='130px' src={PaidStamp} alt='Paid' /></Box>}
                    <table className="table w-50 table-light ms-auto">
                      <tbody>
                        <tr>
                          <th>Total</th>
                          <td>{amount || 0}</td>
                        </tr>
                        <tr>
                          <th>Discount</th>
                          <td>{discount || 0}</td>
                        </tr>
                        <tr>
                          <th>Net Amount</th>
                          <td>{totalAmount || 0}</td>
                        </tr>
                        <tr>
                          <th>Advance</th>
                          <td>{advanceAmount || 0}</td>
                        </tr>
                        <tr>
                          <th>Balance</th>
                          <td>{remainingAmount || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Box>
                  )}
                </div>
              </div>
              <div>
                <p className="text-center">
                  Page {ind + 1}/{createPages(orderDetails).length}
                </p>
                <PageFooter />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PrintDocument;
